module.exports = __webpack_public_path__ + "0263297181df2254751aaa3cb738717a.fbx";